import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { DataMiningService } from '../../services/DataMiningService'
import { Message } from 'primeng/api/message';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/AlertService';

@Component({
  selector: 'app-datamining-search',
  templateUrl: './datamining-search.component.html',
  styleUrls: ['./datamining-search.component.scss']
})
export class DataMiningSearchComponent implements OnInit {
    msgs: Message[];
    transactions: any[] = [];
    searchStr: string = '';
    transCols: any[];
    showLanguage: boolean = true;
    queryParams: any;
    currentCrumb: any;

    constructor(private breadcrumbService: AppBreadcrumbService,
                private dataminingService: DataMiningService,
                private route: ActivatedRoute,
                private router: Router,
                private alertService: AlertService) { }

    ngOnInit(): void {
        this.currentCrumb = this.breadcrumbService.dataMining;
        this.breadcrumbService.setItems([this.currentCrumb]);

        this.transCols = [
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'NaiOffice', header: 'NAI Office' },
            { field: 'PropertyType', header: 'Property Type' },
            { field: 'SellerLegalName', header: 'Seller Legal Name' },
            { field: 'BuyerLegalName', header: 'Buyer Legal Name' },
            { field: 'Location', header: 'Location' },
            { field: 'NAIBroker', header: 'NAI Broker' },
        ];

        this.RetrieveQueryParams();
        this.ReloadSearchFields();
        if (this.queryParams.recent) {
            this.searchTransactions();           
        }
    }

    RetrieveQueryParams(): void {
        if (this.currentCrumb.id != undefined && this.breadcrumbService.crumb != undefined && this.breadcrumbService.crumb.id != undefined) {
            if (this.breadcrumbService.crumb.id == this.currentCrumb.id) {
                this.queryParams = this.breadcrumbService.crumb.queryParams;
                this.breadcrumbService.crumb.queryParams = { 'recent': false, 'searchString': '' };
            }
        }
        else {
            this.queryParams = { recent: false };
        }
    }

    private ReloadSearchFields() {
        this.queryParams.searchString ? this.searchStr = this.queryParams.searchString : this.searchStr = '';     
    }

    UpdateBreadCrumbQueryParams() {
        this.breadcrumbService.crumb = this.currentCrumb;
        this.breadcrumbService.crumb.queryParams = { 'recent': true, 'searchString': this.searchStr};
    }

    searchTransactions() {
        this.showLanguage = false;    
        if (this.searchStr != undefined && this.searchStr != '') {
            this.dataminingService.GetData(this.searchStr).subscribe(
                result => {
                    var data = JSON.parse(result);                    
                    this.transactions = [];
                    if (data != undefined && data.qdbapi != undefined && data.qdbapi.record != undefined && data.qdbapi.record.length > 0) {
                        for (let item of data.qdbapi.record) {
                            var transaction = { Id: 0, NaiOffice: "", PropertyType: "", SellerLegalName: "", BuyerLegalName: "", Location: "", NAIBroker:"" };
                            transaction.Id = item["@rid"];
                            transaction.NaiOffice = this.GetValue(item.f[0]);
                            transaction.PropertyType = this.GetValue(item.f[1]);
                            transaction.SellerLegalName = this.GetValue(item.f[2]);
                            transaction.BuyerLegalName = this.GetValue(item.f[3]);
                            transaction.Location = this.GetLocation(item.f[4], item.f[5], item.f[6]);
                            transaction.NAIBroker = this.GetBrokerName(item.f[7], item.f[8]);
                            this.transactions.push(transaction);
                        }
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while getting data!');
                }
            );
        }
        else {
            this.alertService.SetMessage('error', 'Can not search for an empty transaction!');        
        }
    }

    GetValue(field) {
        return field["#text"];
    };

    GetLocation(city, state, country) {
        var citystr = (this.GetValue(city) === undefined || this.GetValue(state) === '') ? '' : this.GetValue(city);
        var statestr = (this.GetValue(state) === undefined || this.GetValue(state) === '') ? '' : ', ' + this.GetValue(state);
        var countrystr = (this.GetValue(country) === undefined || this.GetValue(country) === '') ? '' : ' ' + this.GetValue(country);
        return citystr + statestr + countrystr;
    };

    GetBrokerName(lastname, firstname) {
        var firstnametr = (this.GetValue(firstname) === undefined || this.GetValue(firstname) === '') ? '' : this.GetValue(firstname);
        var lastnamestr = (this.GetValue(lastname) === undefined || this.GetValue(lastname) === '') ? '' : ' ' + this.GetValue(lastname);       
        return firstnametr + lastnamestr;
    };

    navToDetail(tran) {
        var url = "/datamining/" + tran.Id;
        this.UpdateBreadCrumbQueryParams();
        this.router.navigate([url]);
    }

    exportExcel() {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.transactions);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "DataMining");
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        });
    }
}
